export default __webpack_public_path__ + "1bead305505ddf68c98869e8ff7aeac3.svg";